import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { eNoteOwnerType } from '../models/enum.model';
import { SimpleResponse } from '../models/generic-response.model';
import { CheckRightsResponse, Contact, ContactConnect, ContactConnect_GetListByOwner, ContactFields, ContactFieldsResponse, ContactObjResponse, ContactResponse, eContactTxtMsgStatus } from '../models/mem-contact-modal';
import { MembershipListRequest, MembershipResponse, MemCaseListRequest, MemCaseResponse, MemContact, MemInsuranceDeductible, MemInsuranceDeductibleListRequest, MemInsuranceDeductibleResponse, REFMem_GetAllResponse, MemPolicyViolationListRequest, MemPolicyViolationResponse, MemPolicyViolation, Membership, MemCase, MemPause, MemPauseListRequest, MemSubscriptionListRequest, MemPauseResponse, MemSubscriptionResponse, MemSubscription } from '../models/membership.model';
import { delayedRetryHttp } from './shared/delayed-retry';
import { UtilityService } from './shared/utility.service';

@Injectable({
    providedIn: 'root'
})
export class ContactService {
    private baseUrl: string;
    private api: string = 'api/Engage/Contact';


    constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
        this.baseUrl = _baseUrl + this.api;
    }


    async contactLoad(encryptedUser: string, contactId: number): Promise<Contact | void> {
        const a = await this.httpClient
            .get<Contact>(`${this.baseUrl}/Contact_Load/${contactId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "contactId - " + contactId, encryptedUser, "MembershipService", "memContact_Get"); });
        return a;
    }

    async getContactDialCode(encryptedUser: string, contactID: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/getContactDialCode/${contactID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "contactID - " + contactID + encryptedUser, "ContactService", "getContactDialCode"); });
        return a;
    }

    async pinnedIsPin(encryptedUser: string, clpUserID: number, ownerID: number, ownerType: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/Pinned_isPinned/${clpUserID}/${ownerID}/${ownerType}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "clpUserID - " + clpUserID + " , " + "ownerID - " + ownerID + " , " + "ownerType - " + ownerType, encryptedUser, "ContactService", "pinnedIsPin"); }); //toPromise();
        return a;
    }

    async updateContactFields(encryptedUser: string, contactFields: ContactFields, clpCompanyId: number, contactID: number, userId: number, transferConfirm: boolean, isMoreFieldsAdded: boolean): Promise<ContactFieldsResponse | void> {
        const a = await this.httpClient.post<ContactFieldsResponse>(`${this.baseUrl}/ContactFields_Update/${clpCompanyId}/${contactID}/${userId}/${transferConfirm}/${isMoreFieldsAdded}`, contactFields, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, contactFields, "r - " + encryptedUser + " , " + "clpCompanyId - " + clpCompanyId + " , " + "contactID - " + contactID + " , " + "userId - " + userId + " , " + "transferConfirm - " + transferConfirm + " , " + "isMoreFieldsAdded - " + isMoreFieldsAdded, encryptedUser, "ContactService", "updateContactFields"); });
        return a;
    }

    async contactFields_Get_Configuration(encryptedUser: string, cLPCompanyID: number, cLPUserID: number): Promise<ContactFieldsResponse | void> {
        const a = await this.httpClient
            .get<ContactFieldsResponse>(`${this.baseUrl}/ContactFields_Get_Configuration/${cLPCompanyID}/${cLPUserID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "cLPCompanyID - " + cLPCompanyID + " , " + "cLPUserID - " + cLPUserID, encryptedUser, "ContactService", "contactFields_Get_Configuration"); }); //toPromise();
        return a;
    }

    async contactConnectListByOwner(encryptedUser: string, contactConnectId: number, strRelationship: string = ""): Promise<ContactConnect_GetListByOwner | void> {
        const a = await this.httpClient
            .get<ContactConnect_GetListByOwner>(`${this.baseUrl}/ContactConnect_GetListByOwner/${contactConnectId}?strRelationship=${strRelationship}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "contactConnectId - " + contactConnectId + " , " + "strRelationship - " + strRelationship, encryptedUser, "ContactService", "contactConnectListByOwner"); });
        return a;
    }

    async deleteContact(encryptedUser: string, contactId: number, userId: number, slurpyId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/Contact_Delete/${contactId}/${userId}/${slurpyId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "contactId - " + contactId + " , " + "userId - " + userId + " , " + "slurpyId - " + slurpyId, encryptedUser, "ContactService", "deleteContact"); }); //toPromise();
        return a;
    }

    async contactFields_Get(encryptedUser: string, contactID: number, clpCompanyId: number, userId: number): Promise<ContactFieldsResponse | void> {
        const a = await this.httpClient
            .get<ContactFieldsResponse>(`${this.baseUrl}/ContactFields_Get/${contactID}/${clpCompanyId}/${userId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "contactID - " + contactID + " , " + "clpCompanyId - " + clpCompanyId + " , " + "userId - " + userId, encryptedUser, "ContactService", "contactFields_Get"); }); //toPromise();
        return a;
    }

    async cmMSettings_GetInfoSiteURL(encryptedUser: string, clpCompanyID: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/CMSettings_GetInfoSiteURL/${clpCompanyID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "cLPCompanyID - ", encryptedUser, "ContactService", "cmMSettings_GetInfoSiteURL"); }); //toPromise();
        return a;
    }

    async pinnedPin(encryptedUser: string, clpUserID: number, ownerID: number, ownerType: eNoteOwnerType): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/Pinned_Pin/${clpUserID}/${ownerID}/${ownerType}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "clpUserID - " + clpUserID + " , " + "ownerID - " + ownerID + " , " + "ownerType - " + ownerType, encryptedUser, "ContactService", "pinnedPin"); }); //toPromise();
        return a;
    }

    async pinnedUnPin(encryptedUser: string, clpUserID: number, ownerID: number, ownerType: eNoteOwnerType): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/Pinned_UnPin/${clpUserID}/${ownerID}/${ownerType}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "clpUserID - " + clpUserID + " , " + "ownerID - " + ownerID + " , " + "ownerType - " + ownerType, encryptedUser, "ContactService", "pinnedUnPin"); }); //toPromise();
        return a;
    }

    async setOptOutTxtMsg(encryptedUser: string, isSetTo: eContactTxtMsgStatus, contactId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/SetOptOutTxtMsg/${isSetTo}/${contactId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "isSetTo - " + isSetTo + " , " + "contactId - " + contactId, encryptedUser, "ContactService", "setOptOutTxtMsg"); }); //toPromise();
        return a;
    }

    async contactConnectupdate(encryptedUser: string, contactConnect: ContactConnect): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/ContactConnect_Save`, contactConnect, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, contactConnect, "r - " + encryptedUser, encryptedUser, "ContactService", "contactConnectupdate"); });
        return a;
    }

    async contactConnectSave(encryptedUser: string, contactConnect: ContactConnect): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/ContactConnect_Create`, contactConnect, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, contactConnect, "r - " + encryptedUser, encryptedUser, "ContactService", "contactConnectSave"); });
        return a;
    }

    async checkCLPuserRight(encryptedUser: string, clpUserID: number, clpCompanyID: number, contactID: number): Promise<CheckRightsResponse | void> {
        const a = await this.httpClient
            .get<CheckRightsResponse>(`${this.baseUrl}/CheckCLPContactRights/${clpUserID}/${clpCompanyID}/${contactID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "cLPCompanyID - ", encryptedUser, "ContactService", "checkCLPuserRight"); }); //toPromise();
        return a;
    }
}
